export { normalizeTr, fmtDate, daysText, STATE_STYLE } from '../employee-overview/utils';

export const WARN_TYPES = {
  insurance: { label: 'Sigorta', field: 'insurance_expiry_date' },
  inspection: { label: 'Muayene', field: 'inspection_expiry_date' },
  maintenance: { label: 'Bakım', field: 'next_maintenance_date' },
  rental: { label: 'Kiralık dönüş', field: 'rental_end_date' },
};

export const DATE_COLS = [
  { key: 'insurance_expiry_date', label: 'Sigorta', warn: 'insurance', soonDays: 30 },
  { key: 'inspection_expiry_date', label: 'Muayene', warn: 'inspection', soonDays: 30 },
  { key: 'next_maintenance_date', label: 'Bakım', warn: 'maintenance', soonDays: 30 },
];

export const FILTERS = [
  { key: 'all', label: 'Hepsi' },
  { key: 'unassigned', label: 'Boşta (şoför yok)' },
  { key: 'rental', label: 'Kiralık' },
  { key: 'maintenance', label: 'Bakımda' },
  { key: 'suspended', label: 'Askıda' },
  { key: 'alerts', label: 'Uyarısı olan' },
  { key: 'missing_info', label: 'Eksik bilgi' },
  { key: 'no_vergunning', label: 'Vergunning yok' },
  { key: 'complete', label: '%100 tamam' },
];

export const matchesFilter = (r, f) => {
  if (f === 'unassigned') return r.status === 'ACTIVE' && r.current_drivers.length === 0;
  if (f === 'rental') return r.ownership_type === 'Kiralık';
  if (f === 'maintenance') return r.status === 'MAINTENANCE';
  if (f === 'suspended') return r.status === 'SUSPENDED';
  if (f === 'alerts') return r.warnings.length > 0;
  if (f === 'missing_info') return r.missing_fields.length > 0;
  if (f === 'no_vergunning') return r.missing_items.includes('Vergunning');
  if (f === 'complete') return r.completion === 100;
  return true;
};

export const dateState = (iso) => {
  if (!iso) return { state: 'missing', days: null };
  const days = Math.round((new Date(`${iso}T00:00:00`) - new Date(new Date().toDateString())) / 86400000);
  return { state: days < 0 ? 'expired' : days <= 30 ? 'soon' : days <= 90 ? 'warn' : 'ok', days };
};

export const STATUS_BADGE = {
  ACTIVE: { label: 'Aktif', cls: 'bg-emerald-50 text-emerald-700 border-emerald-200' },
  MAINTENANCE: { label: 'Bakımda', cls: 'bg-violet-100 text-violet-700 border-violet-300' },
  SUSPENDED: { label: 'Askıda', cls: 'bg-rose-100 text-rose-700 border-rose-300' },
};

export const money = (v) => (v || v === 0 ? `€${Number(v).toLocaleString('tr-TR', { maximumFractionDigits: 2 })}` : '—');
